<template>
  <div class="term-of-acceptance-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${termId ? 'Editar' : 'Cadastrar'}`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'terms-of-acceptance.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <term-of-acceptance-form
        @submit="onSubmit"
        :id="termId"
        :errors="errors"
        :saving="isSaving"
      ></term-of-acceptance-form>
    </app-card>
  </div>
</template>

<script>
import TermOfAcceptanceForm from '@/components/Forms/TermOfAcceptanceForm.vue';
import TermOfAcceptanceService from '@/services/term-of-acceptance.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'term-of-acceptance-form-page',
  mixins: [ToastMixin],
  components: {
    TermOfAcceptanceForm,
  },
  data: () => {
    return {
      termId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.termId && this.save(data);
      this.termId && this.update(this.termId, data);
    },
    save(data) {
      this.isSaving = true;
      TermOfAcceptanceService.save(data)
        .then(() => {
          this.toastify('Termo cadastrado com sucesso!');
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(message || 'Erro ao tentar cadastrar Termo', 'error');
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      TermOfAcceptanceService.update(id, data)
        .then(() => {
          this.toastify('Termo atualizado com sucesso!');
          this.$router.push({ name: 'terms-of-acceptance.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(message || 'Erro ao tentar atualizar Termo', 'error');
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.termId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
